module.exports = __webpack_public_path__ + "static/media/ballAppearSlow.04ca5433.mp3";